import { BonusInstanceStatus, BonusProductType } from '@atlas/bonuses';

import { UI_GROUP } from './bonusFeedUtils';
import {
  formatFinishedDateDDMMYYYY,
  getBonusCountdownEndMs,
  getFreespinCountdownEndMs,
  resolveExpiredEndMs,
} from './bonusTimeFormat';

export const BONUS_CARD_PRODUCT = {
  [BonusProductType.SPORTSBOOK]: 'sport',
  [BonusProductType.CASINO]: 'casino',
};

export const resolveBonusType = entity => BONUS_CARD_PRODUCT[entity.productType] ?? 'casino';

export const resolveFinanceForCurrency = (row, currency) => {
  const list = row.financeDataList;
  if (!list?.length) return null;
  return list.find(f => f.currency === currency) || list[0];
};

export const resolveDisplayCurrency = (finance, row, wallet) =>
  finance?.currency || row.currency || wallet?.currency || '';

export const resolveBonusStatus = entity =>
  entity.status || entity.bonusStatus || BonusInstanceStatus.ACTIVATION_READY;

export const resolveBonusInstanceDisplayStatus = entity => {
  const status = resolveBonusStatus(entity);
  return status === BonusInstanceStatus.PENDING || status === BonusInstanceStatus.PENDING_ACTIVATION
    ? BonusInstanceStatus.IN_PROGRESS
    : status;
};

export const resolveFinishedDate = (row, fallback = '—') => {
  const source = row.endTime ?? row.expirationTime ?? row.wagerStartTime ?? row.createTime;
  return (
    formatFinishedDateDDMMYYYY(source) || formatFinishedDateDDMMYYYY(row.expirationTime) || fallback
  );
};

// FT-8580: an expired instance shows the date it went Expired. D3 (no-deposit)
// and D4 (regular freespin) use a type-specific source via resolveExpiredEndMs;
// deposit-like bonuses fall back to the endTime-first cascade (resolveFinishedDate).
export const resolveFinishedExpiryDate = row => {
  if (resolveBonusStatus(row) !== BonusInstanceStatus.EXPIRED) return '';
  const ms = resolveExpiredEndMs(row);
  return (ms != null && formatFinishedDateDDMMYYYY(ms)) || resolveFinishedDate(row, '');
};

export const resolveCountdownMs = (entity, kind, uiGroup, isFinished) => {
  if (isFinished) return undefined;
  const ms =
    kind === 'bonus' ? getBonusCountdownEndMs(entity, uiGroup) : getFreespinCountdownEndMs(entity);
  return ms ?? undefined;
};

export const resolveWageringProps = (entity, kind, uiGroup, displayCurrency, formatter) => {
  if (uiGroup !== UI_GROUP.ACTIVATED || kind !== 'bonus') return null;

  const totalWagerAmount = entity.requiredWagering ?? 0;
  const wageredAmount = entity.wagering ?? 0;

  return {
    totalWagerAmount,
    totalWagerAmountLabel: formatter(totalWagerAmount),
    wagerMultiplier: entity.wager || entity.copiedBonusSettings?.wager || 0,
    wageredAmount,
    wageredAmountLabel: formatter(wageredAmount),
    wageringCurrency: displayCurrency,
  };
};
